import React from 'react'

import { number } from 'prop-types'

function EndToEndServiceIcon({ width = 16, height = 16, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.3335 5.33301C1.3335 4.59663 1.93045 3.99967 2.66683
        3.99967H13.3335C14.0699 3.99967 14.6668 4.59663 14.6668
        5.33301V13.333C14.6668 14.0694 14.0699 14.6663 13.3335 14.6663H2.66683C1.93045 14.6663 1.3335 14.0694 1.3335
        13.333V5.33301ZM13.3335 5.33301L2.66683 5.33301V13.333H13.3335V5.33301Z"
        fill="#73ABF5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.66683 2.66634C4.66683 1.92996 5.26378 1.33301 6.00016
        1.33301H10.0002C10.7365 1.33301 11.3335 1.92996 11.3335
        2.66634V4.66634H10.0002V2.66634H6.00016V4.66634H4.66683V2.66634Z"
        fill="#73ABF5"
      />
      <path
        d="M2.66683 9.33301H13.3335V13.333H2.66683V9.33301Z"
        fill="#73ABF5"
      />
      <path
        d="M6.66683 7.99967H9.3335V6.66634H6.66683V7.99967Z"
        fill="#73ABF5"
      />
    </svg>
  )
}

EndToEndServiceIcon.propTypes = {
  width: number,
  height: number,
}

export default EndToEndServiceIcon
